import { KotlinLoggingConfiguration_getInstance2afdiujdk3hao as KotlinLoggingConfiguration_getInstance } from '../../../../../kotlin-logging/io/github/oshai/kotlinlogging/KotlinLoggingConfiguration.mjs';
import {
  Level_INFO_getInstance1jaw01kotd0ox as Level_INFO_getInstance,
  Level_DEBUG_getInstance1dj873l5gwu6j as Level_DEBUG_getInstance,
} from '../../../../../kotlin-logging/io/github/oshai/kotlinlogging/Level.mjs';
import { JsonFormatter_instance2hc6t42c212a9 as JsonFormatter_instance } from './JsonFormatter.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function initializeLogging(developmentMode) {
  var tmp = KotlinLoggingConfiguration_getInstance().direct_1;
  var tmp_0;
  if (developmentMode) {
    tmp_0 = Level_DEBUG_getInstance();
  } else {
    tmp_0 = Level_INFO_getInstance();
  }
  tmp.set_logLevel_41gy7l_k$(tmp_0);
  KotlinLoggingConfiguration_getInstance().direct_1.set_formatter_z89jgy_k$(JsonFormatter_instance);
}
//region block: exports
export {
  initializeLogging as initializeLogging2wy35dn799fjs,
};
//endregion

//# sourceMappingURL=InitializeLogging.mjs.map
